import api from './api';

export const storeAdvertInteraction = async ({
  position,
  adverts_id,
  interaction_type,
  web_url,
  states_id,
  category_id,
  useWebContent = false,
}) => {
  try {
    const normalizedStateId = Number(states_id || 0);
    const normalizedCategoryId = Number(category_id || 0);

    const payload = {
      position,
      adverts_id,
      interaction_type,
      web_url,
      ...(normalizedStateId > 0 ? { states_id: normalizedStateId } : {}),
      ...(normalizedCategoryId > 0 ? { category_id: normalizedCategoryId } : {}),
    };

    const endpoint = useWebContent ? '/web-content/store-advert-interaction' : '/store-advert-interaction';
    const response = await api.post(endpoint, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
